import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";

import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Colors from "../../constants/Colors";

const styles = theme => ({
  main: {
    flex: 1,
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  progress: {
    // borderRadius: "50%",
    borderRadius: 8,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    // borderWidth: 1,
    backgroundColor: Colors.main,
    color: "#fff",
    fontWeight: "bold",
    marginLeft: 15
  },
  title: {
    color: Colors.text,
    marginBottom: -15,
    fontWeight: "bold"
  },
  bottom: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }
});

const getColorRange = progress => {
  if (progress < 45) {
    return "#ff0000";
  } else if (progress < 60) {
    return Colors.yellow;
  } else if (progress < 80) {
    return "#38ef7d";
  }
  return Colors.main;
};

class CategoryProgressBar extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <Typography variant="h7" className={classes.title}>
          {this.props.title}
        </Typography>
        <div className={classes.bottom}>
          <ProgressBar
            // height={45}
            height={15}
            width={"95%"}
            percent={this.props.progress}
            // filledBackground="linear-gradient(to right, #fefb72, #f0bb31)"
            // filledBackground={getColorRange(this.props.progress)}
            // filledBackground={"linear-gradient(to right, #11998e, #38ef7d)"}
            // filledBackground={"linear-gradient(to right, #6A82FB, #FC5C7D)"}
            filledBackground={"#38ef7d"}
          />
          <p
            className={classes.progress}
            style={{ backgroundColor: getColorRange(this.props.progress) }}
          >
            {this.props.progress / 10}
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CategoryProgressBar);
